define('actions/followed-entities',[
    "jquery",
    "underscore",
    "backbone",
    "dispatcher/AppDispatcher",
    "constants/actiontypes",
    "shared/crm"
], 
function ($, _, Backbone, AppDispatcher, Constants, CRM) {
    return Backbone.Model.extend({
        init: function(params) {
        },
        addFollowed: function (params) {
            AppDispatcher.dispatch({
                actionType: Constants.CREATE_FOLLOWED_ENTITY,
                data: params
            });
        },
        deleteItem: function(guid) {
            AppDispatcher.dispatch({
                actionType: Constants.DELETE_FOLLOWED_ENTITY,
                guid: guid
            });
        },
        pull: function (onComplete) {
            var followed = [];
            var self = this;

            window.api.request("follow").each(function iterator(index, item) {
                followed.push({
                    title: item.data.entity.title,
                    guid: item.data.entity.guid,
                    sender: item.data.entity.owner,
                    created_at: new Date(item.data.created_at),
                    type: item.data.entity_type,
                    links: item.links
                });
            }, function () {
                self.addFollowed(followed);
                if (typeof onComplete === "function") {
                    onComplete();
                }
            });
        },
        unfollow: function(guid, type, onComplete) {
            var self = this;
            window.api.request("follow", guid).delete({type: type}).done(function() {
                self.deleteItem(guid);

                if(typeof onComplete === "function") {
                    onComplete();
                }
            });
        },
    });
});
